import * as React from 'react';
import { Helmet } from 'react-helmet';
import { ErrorBoundary } from '../errorHandling/ErrorBoundary';
import { useTheme } from '../../theming/useTheme';

const componentConfigurationKey = 'mobileTopBar';

interface MobileTopBarColorProps {
  backgroundColor: string
}

export const MobileTopBarColorComponent: React.FunctionComponent<MobileTopBarColorProps> = props => {
  const { backgroundColor } = props;
  return (
    <Helmet>
      <meta name="theme-color" content={backgroundColor} />
    </Helmet>
  );
};

const mapThemeProps = (theme: MobileTopBarColorProps) => ({
  backgroundColor: theme.backgroundColor,
});

export const MobileTopBarColor = () => {
  const themeContext = useTheme(componentConfigurationKey, mapThemeProps);
  return <ErrorBoundary><MobileTopBarColorComponent {...themeContext} /></ErrorBoundary>;
};
